import type { FC } from 'react'
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import NavigationV2 from '@segment/templates/Navigation2'
import Footer from '@segment/templates/Footer/Footer'

import { useRelatedRecipesQuery, useUseCaseQuery } from '@segment/api/routes/useCases/queries'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import RelatedRecipes from './components/RelatedRecipes'
import GettingStarted from './components/GettingStarted'

const copy = {
  pageTitle: `Twilio Segment Use Cases`,
  pageDescription: `Explore top use cases for Twilio Segment and the tools that power them. Implement Segment once, integrate 250+ tools with the flip of a switch, and unlock thousands of new uses cases for marketing, personalization, analytics, and more.`,
}

export interface UseCasesSingleProps {
  slug: string
}
const UseCaseSingleView: FC<UseCasesSingleProps> = ({ slug }) => {
  const theme = useTheme()
  const { data: useCase } = useUseCaseQuery({ args: [slug] })
  const { data: recipes } = useRelatedRecipesQuery({ args: [slug] })

  if (!useCase || !recipes) throw new Error(`Use Case or recipes is missing. Make sure it's preloaded`)

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={copy.pageTitle}
        pageDescription={copy.pageDescription}
        bodyBackground={theme.palette.neutrals.white[100]}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <NavigationV2 />
        <Hero useCase={useCase} />
        <Main>
          <RelatedRecipes recipes={recipes} />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

export default UseCaseSingleView

const Main = styled.main``
